import React from 'react'
import style from './style.module.less'
import EditorPanel from '../EditorPanel'
import UploadField from '@common/UploadField'
import cls from 'classnames'

const getImageType = (type = 1) => {
  return {
    1: '作品',
    2: '客照'
  }[+type]
}

export default props => {
  const {
    data,
    showPath,
    showRichText, // 文本内容
    maxLength,
    kind,
    content, // showRichText为true时的的富文本{text: '<div>aaa</div>'}
    status, //  选中状态，选中时会出现蒙版、替换按钮，
    index,
    onClick,
    onCopy,
    onMoveUp,
    onMoveDown,
    onReplace,
    onPictureReplace, // 点击替换图片按钮的事件
    onDelete,
    isCase, // 传过来的是property_id 只有相关案例里面传了() 干啥的??
    children,
    isSessionPicture
  } = props
  return (
    <div
      className={style.panel}
      style={{
        paddingBottom: !isCase ? 0 : 20,
        marginBottom: isSessionPicture ? 8 : 0
      }}
      onClick={e => {
        e.nativeEvent.stopImmediatePropagation()
      }}
    >
      <div className={style.imageGroup} onClick={onClick}>
        {status && (
          <div className={style.mask} id="shadowBoxActive">
            {onPictureReplace && !showRichText ? (
              <UploadField onOk={onPictureReplace && onPictureReplace()}>
                {({ provided }) => (
                  <div className={style.maskBtn} {...provided}>
                    替换
                  </div>
                )}
              </UploadField>
            ) : (
              !children &&
              !showRichText &&
              !isCase && (
                <div
                  className={style.maskBtn}
                  onClick={onReplace}
                  style={{
                    marginTop: isCase && isCase != 6 ? -64 : 0
                  }}
                >
                  替换
                </div>
              )
            )}
          </div>
        )}
        {isCase &&
          isCase == 6 && (
            <div className={cls('center', style.caseInfo)}>
              <p className={style.caseInfoTitle}>
                {getImageType(data.meal_type)}
              </p>
              <p className={style.caseInfoDate}>
                {(data.set_meal_created_at || '').split(' ')[0]}
              </p>
            </div>
          )}
        {isCase &&
          isCase != 6 &&
          data.example_relation_info.video && (
            <img
              className={style.videoIcon}
              src="//qnm.hunliji.com/o_1cnbhtmk6iu515pf1drl1v991aqa9.png"
            />
          )}
        {showPath && (
          <img
            className={isCase ? style.showPathCase : style.showPath}
            src={`${showPath}?imageView2/2/w/343`}
          />
        )}
        {isCase &&
          isCase != 6 && (
            <div className={style.caseFooter}>
              <p className={style.caseFooterTitle}>{data.title}</p>
              <div className={style.caseFooterTag}>
                <div className={cls(style.caseGroup, style.marksWrapper)}>
                  {data.example_relation_info.marks &&
                    // data.example_relation_info.marks.map((el, i) => (
                    [
                      ...data.example_relation_info.marks,
                      ...data.example_relation_info.marks
                    ].map((el, i) => (
                      <p key={i} className={style.marks}>
                        {el.name}
                      </p>
                    ))}
                </div>
                <div className={style.caseGroup}>
                  <img
                    className={style.icon}
                    src="//qnm.hunliji.com/o_1d21dn7801gucm2ba2ck6ih8ue.png"
                  />
                  <img
                    className={style.icon}
                    src="//qnm.hunliji.com/o_1d21dn4h7i7rf3r1kdr1vnu1ikv9.png"
                  />
                </div>
              </div>
            </div>
          )}
        {showRichText &&
          content &&
          Object.prototype.toString.call(content.text) ===
            '[object String]' && (
            <div
              className={style.container}
              style={{
                color: content.text ? '#333333' : '#aaaaaa'
              }}
              dangerouslySetInnerHTML={{
                __html: content.text || '<p>请在右侧编辑内容</p>'
              }}
            />
          )}
        {children}
      </div>

      {status && (
        <EditorPanel
          index={index}
          maxLength={maxLength}
          onDelete={onDelete}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onCopy={+kind !== 3 ? '' : onCopy}
          onReplace={onReplace && onReplace()}
        />
      )}
    </div>
  )
}
